import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import Alert from '@mui/material/Alert';
import EtaEndDate from "../../../components/EtaEnd";

function OpenTripForm5({ nextStep, prevStep, handleChange, values }) {
  const [errors, setErrors] = useState({});

  const formIsValid = () => {
    const formErrors = {};

    if (!values.etaTripEnd)
      formErrors.etaTripEnd = "Estimated Trip End Datetime is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    prevStep();
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <EtaEndDate
          id="est_trip_end"
          name="est_trip_end"
          value={values.etaTripEnd}
          onChange={handleChange("etaTripEnd")}
          label={"Estimated Trip End Datetime"}
        />
      </Box>
      {errors.etaTripEnd && <Alert severity="error">{errors.etaTripEnd}</Alert>}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default OpenTripForm5;
